import React from 'react';

import Cell from '../Cell';
import { FloatingCellMobileProps } from '../types';

const FloatingCellMobile = ({
    config,
    item,
    renderContent,
}: FloatingCellMobileProps) => (
    <Cell
        config={config}
        item={item}
        renderContent={renderContent}
        selected={false}
        focusable={false}
    />
);

export default FloatingCellMobile;
